import logoImg from "../assets/logo.png";

export default function Logo({ className = "", size = "md" }) {
  const heightClass = className.match(/\bh-\S+/) ? "" : (size === "sm" ? "h-8" : size === "lg" ? "h-[52px]" : "h-11");
  return (
    <img
      src={logoImg}
      alt="SAALUVARS"
      className={`${heightClass} ${className} w-auto object-contain`}
      data-testid="brand-logo"
    />
  );
}
